import React from "react";

const CPP_Debugging = () => {
  return (
    <div>
      <h1>CPP_Debugging Component</h1>
      <p>Content for CPP_Debugging goes here...</p>
    </div>
  );
};

export default CPP_Debugging;
